import React from "react";
import { CheckCircle2, GraduationCap } from "lucide-react";
import { profile, aboutText, aboutHighlights } from "../data/mock";

const About = () => {
	return (
		<section id="about" className="relative py-24 lg:py-32">
			<div className="max-w-7xl mx-auto px-6 lg:px-10">
				<div className="grid lg:grid-cols-12 gap-12 items-start">
					<div className="lg:col-span-5">
						<div className="sticky top-28">
							<div className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.2em] text-teal-400 mb-4">
								<span className="w-8 h-px bg-teal-400" /> 01 — About
							</div>
							<h2 className="font-display text-4xl lg:text-5xl font-bold leading-tight">
								Engineer by training,
								<br />
								<span className="text-teal-300">Problem solver by instinct.</span>
							</h2>
							<div className="mt-8 rounded-xl overflow-hidden border border-teal-500/15 relative group">
								<img src="https://images.pexels.com/photos/9242832/pexels-photo-9242832.jpeg" alt="Engineering workspace" className="w-full h-72 object-cover grayscale-[35%] group-hover:grayscale-0 transition-all duration-500" />
								<div className="absolute inset-0 bg-gradient-to-t from-[#04100f] via-transparent to-transparent" />
							</div>
						</div>
					</div>

					<div className="lg:col-span-7">
						<div className="space-y-5 text-lg text-slate-300 leading-relaxed">
							{aboutText.map((p, i) => (
								<p key={i}>{p}</p>
							))}
						</div>

						<div className="mt-10 grid sm:grid-cols-2 gap-3">
							{aboutHighlights.map((h) => (
								<div key={h} className="flex items-start gap-3 p-4 rounded-lg bg-[#08201d]/60 border border-teal-500/10 hover:border-teal-400/40 transition-colors">
									<CheckCircle2 className="w-5 h-5 text-teal-400 mt-0.5 shrink-0" />
									<span className="text-slate-200 text-sm">{h}</span>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default About;
